import { UniformsLib, UniformsUtils, Color, Vector3 } from "three";
import { GLOBAL_UNIFORMS } from "../GlobalUniforms";
//  glslify is used for including GLSL shader code
const glslify = require("glslify");
const VERTEX_SHADER = require("./CustomPoints.vert");
const FRAGMENT_SHADER = require("./CustomPoints.frag");
export const CUSTOM_POINTS_VERTEX_SHADER = VERTEX_SHADER && glslify(VERTEX_SHADER);
export const CUSTOM_POINTS_FRAGMENT_SHADER = FRAGMENT_SHADER && glslify(FRAGMENT_SHADER);
export const CUSTOM_POINTS_SHADER = {
    uniforms: UniformsUtils.merge([
        UniformsLib.common,
        UniformsLib.lights,
        {
            pointSize: { value: 0.02 },
            pointColor: { value: new Color(0x003333) },
            pointCloudOrigin: { value: new Vector3(0, 0, 0) }
        }
    ]),
    vertexShader: CUSTOM_POINTS_VERTEX_SHADER,
    fragmentShader: CUSTOM_POINTS_FRAGMENT_SHADER
};
CUSTOM_POINTS_SHADER.uniforms.cameraCenterWorldPosition = GLOBAL_UNIFORMS.cameraCenterWorldPosition;
CUSTOM_POINTS_SHADER.uniforms.worldScale = GLOBAL_UNIFORMS.platformScale;
